/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { TableCell, TableRow, Checkbox } from "@mui/material";
import clsx from "clsx";
import { PurchaseGoodsHistory } from "../../../../../config/constant";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import SearchText from '../../../../Shared/components/SearchText';
import { checkCRUDPermission, checkComponentPermission, getColumnWidth, idNamingConversion } from "../../../../../helpers/utilities";
import { Link, NavLink } from "react-router-dom";
import moment from 'moment';
import { Image, Space, Dropdown, Menu } from "antd";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import { DeliveryChallan } from "./Block";


export const ListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy, onSelected, details, loadMore, loadMoreContent, selected, handleClick, loadMoreTask, search, customerId, roleManagement } = props;
    const [open, setOpen] = useState(false);
    const [head, setHead] = useState(PurchaseGoodsHistory);

    useEffect(() => {
        if (customerId) {
            setHead([{ 'key': 'checkbox', 'name': 'Checkbox' }, ...PurchaseGoodsHistory]);
        } else {
            setHead(PurchaseGoodsHistory);
        }
    }, [customerId]);

    const isSelected = (name) => selected.indexOf(name) !== -1;

    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={head}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                width={true}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                details={details}
                selected={selected}
                onSelected={(value) => onSelected(value)}
                className={classes.margin15t}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={PurchaseGoodsHistory.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}  >
                                                {
                                                    customerId && <TableCell className={clsx('checkbox', classes.tablealign)} onClick={(e) => handleClick(e, data.id)} padding="checkbox">
                                                        <Checkbox
                                                            color="primary"
                                                            checked={isSelected(data.id)}
                                                        />
                                                    </TableCell>
                                                }
                                                <TableCell style={{ width: getColumnWidth(PurchaseGoodsHistory, 0) }} className={clsx('checkbox', classes.tablealign)}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Delivery Note History', 'view', 'Sales') ?
                                                            <Link id={idNamingConversion('View_' + data.id, 'PurchaseGoodsHistory', 'Link')} style={{ width: getColumnWidth(PurchaseGoodsHistory, 0) }} to={`/purchase/transactions/goods-receipt-note/${data.id}/view`}
                                                                className={clsx(classes.color, classes.bold)}>{data.serialNo ? data.serialNo : '---'}</Link>
                                                            : <span style={{ width: getColumnWidth(PurchaseGoodsHistory, 0) }}>{data.serialNo ? data.serialNo : '---'}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(PurchaseGoodsHistory, 1) }}><span style={{ width: getColumnWidth(PurchaseGoodsHistory, 1) }} >{data?.supplier_name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(PurchaseGoodsHistory, 2) }}><span style={{ width: getColumnWidth(PurchaseGoodsHistory, 2) }} >{data?.supplier_email || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(PurchaseGoodsHistory, 3) }}><span style={{ width: getColumnWidth(PurchaseGoodsHistory, 3) }} >{data?.supplier_phone || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(PurchaseGoodsHistory, 4) }}><span style={{ width: getColumnWidth(PurchaseGoodsHistory, 4) }} >{moment(data?.deliveryDate).format('DD MMM YYYY')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(PurchaseGoodsHistory, 5) }}><span style={{ width: getColumnWidth(PurchaseGoodsHistory, 5) }} >{data?.deliveryStatus || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(PurchaseGoodsHistory, 5) }}>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Goods Receipt Note', 'view', 'Purchase') &&
                                                            <Link id={idNamingConversion('View_' + data.id, 'PurchaseGoodsHistory', 'Icon')} to={`/purchase/transactions/goods-receipt-note/${data.id}/view`}>
                                                                <Image
                                                                    src={ViewIcon}
                                                                    preview={false}
                                                                />
                                                            </Link>
                                                        }
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    <Menu.Item key={"arrow"} className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Goods Receipt Note', 'Ellipsis Action', 'Share Document') &&
                                                                        <Menu.Item key={"document"}>
                                                                            <NavLink
                                                                                to={`#`}
                                                                                onClick={() => setOpen(data)}
                                                                                id={idNamingConversion('ShareDocument_' + data.id, 'PurchaseGoodsHistory', 'Icon')}>Share Document</NavLink>
                                                                        </Menu.Item>
                                                                    }
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Goods Receipt Note', 'Ellipsis Action', 'Create Invoice') && data?.deliveryStatus === 'DELIVERED' &&
                                                                        <Menu.Item key={"invoice"}>
                                                                            <Link to={`/purchase/transactions/goods-receipt-note/${AESEncrypt(
                                                                                {
                                                                                    name: data?.supplier_name || '',
                                                                                    phone: data?.supplier_phone || '',
                                                                                    email: data?.supplier_email || '',
                                                                                    deliveryIds: [data.id],
                                                                                    deliveryId: data.id,
                                                                                    single: true
                                                                                })}/invoice`} id={idNamingConversion('CreateInvoice_' + data.id, 'PurchaseGoodsHistory', 'Icon')}>Create Invoice</Link>
                                                                        </Menu.Item>
                                                                    }
                                                                </Menu>
                                                            }>
                                                            <Image id={idNamingConversion('Elipsis_' + data.id, 'customerInvoiceHistory', 'Icon')} src={ElipsisIcon} preview={false} />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={PurchaseGoodsHistory.length}>
                                                    {
                                                        search !== '' ? <SearchText /> :
                                                            <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                                All Delivery will be listed here.
                                                            </p>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            {console.log(open)}
            <DeliveryChallan
                {...props}
                visible={open ? true : false}
                details={open}
                classes={classes}
                clsx={clsx}
                handleClose={() => setOpen(false)}

            />
        </>

    )
}